import React, { lazy } from 'react';
import { ShieldCheck } from 'lucide-react';
export const StatsBanner = () => {
  const chips = ['Planillas', 'Escalas', 'Informes PAMI', 'Derivaciones', 'Comunicación', 'Documentación', 'Emergencias'];
  return <section className="py-8 md:py-12 bg-teal text-white" data-id="element-331">
      <div className="max-w-6xl mx-auto px-4 text-center" data-id="element-332">
        <div className="inline-flex items-center gap-2 bg-navy/20 px-3 py-1 rounded-full text-xs md:text-sm font-bold mb-6 md:mb-8" data-id="element-333">
          <ShieldCheck className="w-3 h-3 md:w-4 md:h-4" data-id="element-334" />
          SISTEMA N°1 EN ARGENTINA
        </div>

        {/* Mundo Digital Logo - 400% scale, transparent (no white background) */}
        <div className="flex justify-center mb-6 md:mb-10" data-id="element-335">
          <img src="https://cdn.magicpatterns.com/uploads/g9giQMGcMKZrXJ7wXov8mh/heylloyd-image-1779467902590-Photoroom.png" alt="Mundo Digital — Sistema Clínico para Terapistas Ocupacionales" loading="lazy" decoding="async" width={400} height={100} className="h-72 md:h-96 w-auto object-contain mt-[-120px] mb-[-120px]" style={{
          filter: 'brightness(0) invert(1)'
        }} data-id="element-336" />
        </div>

        <div className="flex flex-row justify-center items-center gap-6 md:gap-12 mb-4 md:mb-8" data-id="element-337">
          <div className="text-center" data-id="element-338">
            <span className="block text-3xl md:text-5xl font-extrabold text-navy leading-none" data-id="element-339">
              +540
            </span>
            <span className="text-xs md:text-lg font-medium" data-id="element-340">pág.</span>
          </div>
          <div className="w-px h-12 md:h-16 bg-white/30" data-id="element-341"></div>
          <div className="text-center" data-id="element-342">
            <span className="block text-3xl md:text-5xl font-extrabold text-navy leading-none" data-id="element-343">
              50+
            </span>
            <span className="text-xs md:text-lg font-medium" data-id="element-344">protocolos</span>
          </div>
        </div>

        <h3 className="text-sm md:text-2xl font-bold mb-4 md:mb-8 max-w-3xl mx-auto leading-relaxed" data-id="element-345">
          Evaluación · AVD · Entorno · Familia · Seguimiento · Identidad
        </h3>

        <div className="flex flex-wrap justify-center gap-1.5 md:gap-3" data-id="element-346">
          {chips.map((chip, i) => <span key={i} className="bg-white/10 border border-white/20 px-2.5 md:px-4 py-1 md:py-2 rounded-full text-[11px] md:text-sm font-medium" data-id="element-347">
              {chip}
            </span>)}
        </div>
      </div>
    </section>;
};